/** @jsx jsx */
import { Fragment } from 'react'
import { css, jsx } from '@emotion/core'
import { RadioButton } from '@livechat/design-system'

const labelsCss = (theme) => css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-weight: 300;

  > span {
    font-size: 15px;
    max-width: 40%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .right {
    text-align: right;
    ${theme.question_color &&
    css`
      color: ${theme.question_color};
    `}
  }

  .left {
    ${theme.question_color &&
    css`
      color: ${theme.question_color};
    `}
  }
`

const scoreCss = css`
  display: flex;
  justify-content: space-evenly;

  .lc-radio__label {
    display: flex;
    flex-direction: column-reverse;
  }

  .lc-radio__text {
    width: 64%;
    text-align: center;
  }
`

const Score = ({ field, fieldIndex, response, setResponse, theme }) => {
  const { range, labels } = field.score

  const resp = response[fieldIndex]

  const numberOfColumns = parseInt(range.max) - parseInt(range.min) + 1

  return (
    <Fragment>
      <div key={`field-${fieldIndex}-${field.question}`} css={scoreCss}>
        {Array.from(
          {
            length: numberOfColumns,
          },
          (_, i) => i + parseInt(range.min)
        )?.map((score) => {
          return (
            <RadioButton
              key={`score-${field.question}-${score}`}
              checked={resp === score}
              onChange={() =>
                setResponse({
                  ...response,
                  [fieldIndex]: score,
                })
              }
            >
              {score}
            </RadioButton>
          )
        })}
      </div>
      {labels.min && labels.max && (
        <div css={labelsCss(theme)}>
          <span className="left">{labels.min}</span>
          <span className="right">{labels.max}</span>
        </div>
      )}
    </Fragment>
  )
}

export default Score
